import type { ArtMetadata, Formats } from "./art-metadata";
import type { MetadataReference, MetadataValues } from "./metadata-schema";

export function canRenameFormat(formats: Formats, name: string, nextName: string): boolean {
  if (!nextName) return false;
  const unsafeName = ["__proto__", "constructor", "prototype"].includes(nextName);
  if (unsafeName) return false;
  if (Object.hasOwn(formats, nextName)) return false;
  return Object.hasOwn(formats, name);
}

function renameFormatDefinition(formats: Formats, name: string, nextName: string): Formats {
  const entries = Object.entries(formats);
  const renamedEntries = entries.map(([key, pattern]) => {
    const renamedKey = key === name ? nextName : key;
    return [renamedKey, pattern];
  });
  return Object.fromEntries(renamedEntries);
}

export function buildRenamedFormatMetadata(
  metadata: ArtMetadata,
  references: MetadataReference[],
  name: string,
  nextName: string,
): ArtMetadata {
  const renamedFormats = renameFormatDefinition(metadata.formats, name, nextName);
  const matchingReferences = references.filter(reference => reference.definition === "formats" && reference.name === name);
  const next = structuredClone(metadata);
  next.formats = renamedFormats;

  // Reference updates mutate only this function's private clone.
  matchingReferences.forEach(reference => {
    const parentPath = reference.path.slice(0, -1);
    const field = reference.path.at(-1)!;
    const parent = parentPath.reduce<MetadataValues>(
      (record, key) => record[key] as MetadataValues,
      next as unknown as MetadataValues,
    );
    parent[field] = nextName;
  });
  return next;
}
